import { Component, computed, Input, Signal, signal, WritableSignal } from '@angular/core';
import { ThemeService } from '../../services/theme/theme.service';

@Component({
  selector: 'toggle-dark',
  standalone: true,
  imports: [],
  templateUrl: './toggle-dark.component.html',
  styleUrl: './toggle-dark.component.scss'
})
export class ToggleDarkComponent {
  isDark!: Signal<boolean>;
  @Input() size: number = 2;
  @Input() classes: string = '';
  @Input() hasLabel: boolean = false;

  constructor(private theme: ThemeService){
    this.isDark = computed(() => this.theme.isDark());
  }

  toggleTheme(){
    this.theme.toggleTheme()
  }
}
